import { ISurveyConfirm } from "@common/models/SurveyConfirm";
import { IValidationError } from "@core/index";
import { createContext } from "react";
import { ISurveyAction } from "./index";

export interface ISurvey {
    surveyConfirm: ISurveyConfirm;
    surveyConfirmError: IValidationError
}

export const SurveyContext = createCtx<ISurvey, ISurveyAction>({ surveyConfirm: {}, surveyConfirmError: {} });

export function createCtx<S, A>(defaultValue: S) {
    const defaultDispatch: React.Dispatch<A> = () => defaultValue;
    const ctx = createContext({
        survey: defaultValue,
        surveyDispatch: defaultDispatch
    });
    return ctx;
}

